import { render } from "./Draggable.vue?vue&type=template&id=3cf87c0e"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"
script.render = render

export default script